/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author Shihan Rahim
 * 02/22/2022
 *
 */

import React from 'react';
import '../../form-elements/formElement.css';
import API from "../../../../../utils/api";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import axios from 'axios';
import FormElementGenerator from "../../form-elements/formElementGenerator";
import Loader from "../../../loader/loader";
import validator from "validator/es";

/**
 * HOC for the accounts form
 */
class AccountsForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = null;

        // get the parameter from URL
        const accountId = this.props.match.params.id;

        // set icons to the header
        if (accountId === undefined) {
            this.state =  {
                accountId: null,
                accountFirstName: '',
                accountLastName: '',
                accountEmail: '',
                accountKey: '',
                accountConfirmedPassword: '',
                accountAdminRoles: [],
                accountEnabled: null,

                isDisplayLoader: true,
                errors: {},

                token: '',
                fields: [
                    {
                        inputType: 'text',
                        labelName: 'First Name: *',
                        inputName: 'accountFirstName',
                        placeholder: 'Please enter the first name here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'text',
                        labelName: 'Last Name: *',
                        inputName: 'accountLastName',
                        placeholder: 'Please enter the last name here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'text',
                        labelName: 'Email: *',
                        inputName: 'accountEmail',
                        placeholder: 'Please enter the email here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'textPassword',
                        labelName: 'Password: *',
                        inputName: 'accountKey',
                        placeholder: 'Please enter the password here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'textPassword',
                        labelName: 'Confirm Password: *',
                        inputName: 'accountConfirmedPassword',
                        placeholder: 'Please confirm the password here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'multiDropdown',
                        labelName: 'Roles *',
                        inputName: 'accountAdminRoles',
                        optionValueName: 'accountAdminRoles',
                        optionLabelName: 'accountAdminRoles',
                        required: true,
                        path: '/account',
                        valueType: 'accountAdminRoles'
                    },
                    {
                        inputType: 'checkbox',
                        labelName: 'Enabled: ',
                        inputName: 'accountEnabled',
                        optionValueName: 'accountEnabled',
                        optionLabelName: 'accountEnabled'
                    }
                ]
            };

            EventEmitter.emit('setPageHeaderData', {
                page: 'accounts',
                pageName: "Accounts",
                pageLink: process.env.REACT_APP_BASE_URL + "/#/home/accounts",
                optionalIcons: ['backIcon','clearFormIcon']
            });
        } else {
            this.state =  {
                accountId: null,
                accountFirstName: '',
                accountLastName: '',
                accountEmail: '',
                accountKey: '',
                accountConfirmedPassword: '',
                accountAdminRoles: [],
                accountEnabled: null,

                isDisplayLoader: true,
                errors: {},

                token: '',
                fields: [
                    {
                        inputType: 'text',
                        labelName: 'First Name: *',
                        inputName: 'accountFirstName',
                        placeholder: 'Please enter the first name here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'text',
                        labelName: 'Last Name: *',
                        inputName: 'accountLastName',
                        placeholder: 'Please enter the last name here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'text',
                        labelName: 'Email: *',
                        inputName: 'accountEmail',
                        placeholder: 'Please enter the email here',
                        value: '',
                        required: true
                    },
                    {
                        inputType: 'multiDropdown',
                        labelName: 'Roles *',
                        inputName: 'accountAdminRoles',
                        optionValueName: 'accountAdminRoles',
                        optionLabelName: 'accountAdminRoles',
                        required: true,
                        path: '/account',
                        valueType: 'accountAdminRoles'
                    },
                    {
                        inputType: 'checkbox',
                        labelName: 'Enabled: ',
                        inputName: 'accountEnabled',
                        optionValueName: 'accountEnabled',
                        optionLabelName: 'accountEnabled'
                    }
                ]
            };

            EventEmitter.emit('setPageHeaderData', {
                page: 'accounts',
                pageName: "Accounts",
                pageLink: process.env.REACT_APP_BASE_URL + "/#/home/accounts",
                optionalIcons: ['backIcon','clearFormIcon','deleteIcon']
            });
        }

        // set the event emitters
        EventEmitter.on('saveFormData', this.handleSubmit);
        EventEmitter.on('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.on('deleteFormData', this.deleteAccount);
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
        EventEmitter.on('clearForm', this.clearForm);
    }

    // set a token to unsubscribe the async call
    CancelToken = axios.CancelToken;
    source = this.CancelToken.source();

    componentDidMount = async () => {
        // get parameter from URL
        const accountId = this.props.match.params.id;

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        // fill the form if not a create partner
        if (accountId !== undefined) {

            const url = '/account?search=%7BaccountId:' + accountId + '%7D';

            await API.get(url, {headers: {Authorization: token}, cancelToken: this.source.token})
                .then(res => {
                    const data = res.data[0];
                    oldState.accountId = (data.accountId !== undefined) ? data.accountId : null;
                    oldState.accountFirstName = (data.accountFirstName !== undefined) ? data.accountFirstName : null;
                    oldState.accountLastName = (data.accountLastName !== undefined) ? data.accountLastName : '';
                    oldState.accountEmail = (data.accountEmail !== undefined) ? data.accountEmail : '';
                    oldState.accountKey = (data.accountKey !== undefined) ? data.accountKey : '';
                    oldState.accountConfirmedPassword = (data.accountKey !== undefined) ? data.accountKey : '';
                    oldState.accountAdminRoles = (data.accountAdminRoles !== undefined) ? data.accountAdminRoles : '';
                    oldState.accountEnabled = (data.accountEnabled !== undefined) ? (data.accountEnabled === 1) : null;

                    oldState.token = token;
                    oldState.isDisplayLoader = false;

                    this.setState(oldState);
                }).catch(er => {
                    oldState.isDisplayLoader = false;
                    this.setState(oldState);
                    this.displayErrorsForAPICalls(er);
                });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        // remove all event emitters
        EventEmitter.off('setPageHeaderData', {});
        EventEmitter.off('saveFormData', this.handleSubmit);
        EventEmitter.off('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.off('deleteFormData', this.deleteAccount);
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
        EventEmitter.off('clearForm', this.clearForm);
        this.source.cancel("cancel accounts async calls");
    };

    /**
     * set the state
     * @param event
     */
    handleChange = event => {
        if (event === null || Array.isArray(event)) {
            let selectedRoles = [];
            if (event !== null) {
                event.forEach(rol => {
                    selectedRoles.push({
                        accountRoleId: this.state.accountId,
                        accountAdminRoleId: rol.value,
                        adminRoleAuthority: rol.label
                    });
                })
            }

            const newState = Object.assign({}, this.state);
            newState.accountAdminRoles = selectedRoles;

            this.setState(newState, ()=> this.validate("accountAdminRoles", selectedRoles));
        } else if (event.target.ariaLabel === 'accountEnabled'||event.target.name === 'accountEnabled') {
            const newState = Object.assign({}, this.state);
            newState.accountEnabled = event.target.checked;

            this.setState(newState);
        } else if (event.optionValueName !== undefined) {
            this.setState({
                [event.optionValueName]: event.value,
                [event.optionLabelName]: event.label
            }, () => {
                this.validate(event.optionValueName, event.value)
            });
        } else if (event.currentTarget !== undefined) {
            const key = event.currentTarget.name;
            const val = event.currentTarget.value;

            this.setState({
                [key]: val
            }, () => {
                this.validate(key, val)
            });
        }
    };

    /**
     * handle the form submission
     */
    handleSubmit = () => {
        // data to be sent
        let data = null;
        // check its a update or create
        if (this.state.accountId !== null) {
            data = {
                accountId: this.state.accountId,
                accountFirstName: this.state.accountFirstName,
                accountLastName: this.state.accountLastName,
                accountEmail: this.state.accountEmail,
                accountKey: this.state.accountKey,
                accountConfirmedPassword: this.state.accountConfirmedPassword,
                accountAdminRoles: this.state.accountAdminRoles,
                accountEnabled: this.state.accountEnabled
            };
        } else {
            data = {
                accountFirstName: this.state.accountFirstName,
                accountLastName: this.state.accountLastName,
                accountEmail: this.state.accountEmail,
                accountKey: this.state.accountKey,
                accountConfirmedPassword: this.state.accountConfirmedPassword,
                accountAdminRoles: this.state.accountAdminRoles,
                accountEnabled: this.state.accountEnabled
            };
        }

        // validate each form field
        for (let [key, value] of Object.entries(data)) {
            this.validate(key, value);
        }

        // check weather there are error messages
        if (Object.values(this.state.errors).find(o => o !== '') === undefined) {
            // check update or create
            if (this.state.accountId !== null) {
                this.updateAccount(data);
            } else {
                this.createAccount(data);
            }
        }
    };

    /**
     * validate the user inputs
     * @param key - input name
     * @param value - input value
     */
    validate = (key, value) => {

        let error = {};

        switch (key) {
            case 'accountFirstName':
                if (value === '')
                    error[key] = "First Name is Required!";
                else if (value === ' ')
                    error[key] = "First Name can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 64))
                    error[key] = "First Name can't have more than 64 characters!";
                else
                    error[key] = "";
                break;
            case 'accountLastName':
                if (value === '')
                    error[key] = "Last Name is Required!";
                else if (value === ' ')
                    error[key] = "Last Name can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 64))
                    error[key] = "Last Name can't have more than 64 characters!";
                else
                    error[key] = "";
                break;
            case 'accountEmail':
                if (value === '')
                    error[key] = "Email is Required!";
                else if (value === ' ')
                    error[key] = "Email can't be an empty space!";
                else if (!validator.isEmail(value))
                    error[key] = "Please enter a valid email!";
                else if ((new TextEncoder().encode(value).length > 128))
                    error[key] = "Email can't have more than 128 characters!";
                else
                    error[key] = "";
                break;
            case 'accountKey':
                if (value === '')
                    error[key] = "Password is Required!";
                else if (value === ' ')
                    error[key] = "Password can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 64))
                    error[key] = "Password can't have more than 64 characters!";
                else
                    error[key] = "";
                break;
            case 'accountConfirmedPassword':
                if (value === '')
                    error[key] = "Please confirm the Password!";
                else if (value !== this.state.accountKey)
                    error[key] = "Password and Confirm Passwords do not match!";
                else
                    error[key] = "";
                break;
            case 'accountAdminRoles':
                if (value.length === 0)
                    error[key] = "Please select at least one role!";
                else
                    error[key] = "";
                break;
            default:
                break;
        }

        const newState = Object.assign({}, this.state);
        newState.errors = Object.assign(newState.errors, error);

        this.setState(newState);
    };

    /**
     * create accounts
     * @param data - the data to create a new accounts
     */
    createAccount = async (data) => {
        await API.post('/account',
            {
                "accountFirstName": data.accountFirstName,
                "accountLastName": data.accountLastName,
                "accountEmail": data.accountEmail,
                "accountKey": data.accountConfirmedPassword,
                "accountAdminRoles": data.accountAdminRoles,
                "accountEnabled": data.accountEnabled ? 1 : 0
            }, {headers: {Authorization: this.state.token}, cancelToken: this.source.token}
        ).then(res => {
            this.setAlert("Success", "Success", "Successfully Created the Account");
            this.props.history.push('/home/accounts');
        }).catch(er => {
            this.displayErrorsForAPICalls(er);
        });
    };

    /**
     * update accounts
     * @param data - updated Account details
     */
    updateAccount = async (data) => {
        await API.put('/account',
            {
                "accountId": data.accountId,
                "accountFirstName": data.accountFirstName,
                "accountLastName": data.accountLastName,
                "accountEmail": data.accountEmail,
                "accountKey": data.accountConfirmedPassword,
                "accountAdminRoles": data.accountAdminRoles,
                "accountEnabled": data.accountEnabled ? 1 : 0
            },{headers: {Authorization: this.state.token}, cancelToken: this.source.token}
        ).then(response => {
            this.setAlert("Success", "Success", "Successfully updated the Account");
            this.props.history.push('/home/accounts');
        }).catch(er => {
            this.displayErrorsForAPICalls(er);
        });
    };

    /**
     * display delete warning message
     */
    displayDeleteWarningMessage = () => {
        if (this.state.accountId !== null) {
            EventEmitter.emit('warningModelData', {
                type: 'account',
                name: this.state.accountEmail
            });
            EventEmitter.emit('openWarningModel', true);
        } else {
            EventEmitter.emit('setAlert', {
                openAlert: true,
                type: "Error",
                isDisplayAlertIcon: true,
                alertMessage: "You are trying to delete before loading the Account Details",
                alertTitle: "Error"
            });
        }

    };

    /**
     * delete a accounts
     * @param data
     */
    deleteAccount = async (data) => {
        if (data && (this.props.match.path === "/home/accounts/:id")) {
            await API.delete('/account?accountId=' + this.state.accountId + '&email=' + this.state.accountEmail, {headers: {Authorization: this.state.token}, cancelToken: this.source.token})
                .then(res => {
                    this.setAlert("Success", "Success", "Successfully Deleted the selected Account");
                    this.props.history.push('/home/accounts');
                }).catch(er => {
                    this.displayErrorsForAPICalls(er);
                });
        }
    };

    displayErrorsForAPICalls = (error) => {
        if (error.response !== undefined && error.response.status === 404) {
            this.setAlert("Error", "Error", "The selected item not found!");
        } else if (error.response !== undefined && error.response.status === 422) {
            const message = error.response.data || "Cannot delete account because related records still reference this account.";
            this.setAlert("Error", "Sorry", message);
        } else if (error.response === undefined || error.response.status === 401) {
            localStorage.removeItem('tmcUser')
            this.props.history.push('/');
        } else {
            this.setAlert("Error", "Error", "Something went wrong");
        }
    };

    /**
     * fire an alert
     * @param alertType
     * @param alertTitle
     * @param alertMessage
     */
    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    /**
     * clear the form
     */
    clearForm = () => {
        const newState = Object.assign({}, this.state);

        newState.accountId = null;
        newState.accountFirstName = '';
        newState.accountLastName = '';
        newState.accountEmail = '';
        newState.accountKey = '';
        newState.accountConfirmedPassword = '';
        newState.accountAdminRoles = [];
        newState.accountEnabled = null;
        newState.errors = {};

        this.setState(newState);
    };

    /**
     * navigate to previous page
     */
    navigateToPreviousPage = () => {
        this.props.history.push('/home/accounts');
    };

    render() {
        return(
            <div role="form" className="container">
                {this.state.isDisplayLoader && <Loader/>}
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Save" onClick={this.handleSubmit}>
                        <i className="fa fa-save fa-lg icon-primary" />
                    </div>
                </div>
                <form>
                    <FormElementGenerator currentState={this.state} handleChange={this.handleChange} />
                </form>
            </div>
        )
    }
}

export default AccountsForm;
